const userGroupHu = {
	userGroupTable: 'User Group',
	userGroupEditForm: 'User Group',
	name: 'Name',
};

export default userGroupHu;